import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  InputGroup,
  FormControl,
  FloatingLabel,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

import { useLocation, useParams } from "react-router";
import PagingNav from "../component/PagingNav";
import { getUserSession } from "../component/userInfo";
import Image from "react-bootstrap/Image";

import "./ReadingBible.css";
import { isList } from "immutable";

const ReadingBible90 = () => {
  const loc = useLocation();

  const [bible, setBible] = useState({});
  const [no, setNo] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [fdate, setFdate] = useState("");
  const [tdate, setTdate] = useState("");
  const [list, setList] = useState([]);

  const [bibleCont, setBibleCont] = useState(""); // modal 값
  const [rowIndex, setRowIndex] = useState(-1);

  const [modalShow, setModalShow] = useState(false);
  const modalClose = () => setModalShow(false);
  const modalOpen = () => setModalShow(true);

  const bibleTitleString =
    "창세기,출애굽기,레위기,민수기,신명기,여호수아,사사기,룻기,사무엘상,사무엘하,열왕기상,열왕기하,역대상,역대하,에스라,느헤미야," +
    "에스더,욥기,시편,잠언,전도서,아가,이사야,예레미야,예레미야애가,에스겔,다니엘,호세아,요엘," +
    "아모스,오바댜,요나,미가,나훔,하박국,스바냐,학개,스가랴,말라기,마태복음,마가복음,누가복음," +
    "요한복음,사도행전,로마서,고린도전서,고린도후서,갈라디아서,에베소서,빌립보서,골로새서,데살로니가전서," +
    "데살로니가후서,디모데전서,디모데후서,디도서,빌레몬서,히브리서,야고보서,베드로전서,베드로후서,요한일서,요한이서,요한삼서,유다서,요한계시록";

  useEffect(() => {
    console.log(">>>>>>", loc.state);
    setNo(loc.state.bible.rb90_no);
    setTitle(loc.state.bible.rb90_title);
    setContent(loc.state.bible.rb90_content);
    setFdate(loc.state.bible.fdate);
    setTdate(loc.state.bible.tdate);
    fetchList();
  }, []);

  const fetchList = async () => {
    const userSession = getUserSession();
    try {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "rb90");
      formData.append("no", loc.state.bible.rb90_no);
      if (loc.state.bible.rb90_no == "0") {
        formData.append("fdate", loc.state.bible.fdate);
      }

      let res = await fetch("https://work.wekoinonia.org/json/rbjesus.php", {
        method: "POST",
        body: formData,
        //headers: new Headers({
        //'Content-Type': 'application/json'
        //  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      });

      let json = await res.json(); //Promise 반환
      console.log(json); // 서버에서 주는 json데이터가 출력 됨
      if (json.list) {
        setList(json.list);
      }
      if (json.rb90_no) {
        setNo(json.rb90_no);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const changeDate = (d, i) => {
    const copyList = [...list];
    copyList[i].rb90_date = d;
    console.log(copyList);
    setList(copyList);
    console.log(list);
  };
  const insertRowDown = (rowIdx) => {
    let currentItem = list.at(rowIdx);
    let newItem = JSON.parse(JSON.stringify(currentItem));
    newItem.rb90_bible = "";
    newItem.rb90_week_title = "";
    let slist = list.slice(rowIdx);
    slist.map((item, index) => {
      item.rb90_daily_no = item.rb90_daily_no * 1 + 1;
      let dt = new Date(item.rb90_date);
      let dcnt = dt.getDay() == 6 ? 2 : 1; // 토요일이면 2일, 그외 1일 추가
      dt.setDate(dt.getDate() + dcnt);
      item.rb90_date = outDate(dt);
      item.weekday = dt.getDay() + 1 + ""; // php와 javascript 차이
      switch (item.weekday) {
        case "1":
          item.weekday_name = "일";
          break;
        case "2":
          item.weekday_name = "월";
          break;
        case "3":
          item.weekday_name = "화";
          break;
        case "4":
          item.weekday_name = "수";
          break;
        case "5":
          item.weekday_name = "목";
          break;
        case "6":
          item.weekday_name = "금";
          break;
        case "7":
          item.weekday_name = "토";
          break;
      }
    });
    const copyList = [...list.slice(0, rowIdx), newItem, ...slist];

    setList(copyList);
  };
  const outDate = (d) => {
    let year = "" + d.getFullYear();
    let month = (d.getMonth() < 9 ? "0" : "") + (d.getMonth() + 1);
    let day = (d.getDate() < 10 ? "0" : "") + d.getDate();

    let ymd = year + "-" + month + "-" + day;
    console.log("ymd :: ", ymd);
    return ymd;
  };
  const deleteRow = (rowIdx) => {
    let prevItem = JSON.parse(JSON.stringify(list.at(rowIdx)));
    let slist = list.slice(rowIdx + 1);
    slist.map((item, index) => {
      let currentItem = JSON.parse(JSON.stringify(item));
      item.rb90_daily_no = prevItem.rb90_daily_no;
      item.rb90_date = prevItem.rb90_date;

      item.weekday = prevItem.rb90_date;
      item.weekday_name = prevItem.weekday_name;
      prevItem = currentItem;
    });
    const copyList = [...list.slice(0, rowIdx), ...slist];

    setList(copyList);
  };
  const modifyRowModal = (rowIdx) => {
    let currentItem = list.at(rowIdx);
    setRowIndex(rowIdx);
    setBibleCont(currentItem.rb90_bible);
    modalOpen();
  };
  const modalModify = () => {
    let currentItem = list.at(rowIndex);
    currentItem.rb90_bible = bibleCont;
    setList(list);
    modalClose();
  };
  const getStartBibleName = (str) => {
    let biNameList = bibleTitleString.split(",");
    let st = "";
    for (let i = 0; i < biNameList.length; i++) {
      if (str.indexOf(biNameList[i]) >= 0) return biNameList[i];
    }
    return "";
  };
  const getEndBibleName = (str) => {
    let biNameList = bibleTitleString.split(",");
    let st = "";
    for (let i = biNameList.length - 1; i >= 0; i--) {
      if (str.indexOf(biNameList[i]) >= 0) return biNameList[i];
    }
    return "";
  };

  const updateRowWeekTitle = () => {
    let weeks = [];
    for (let i = 1; i <= 20; i++) {
      // 16이지만 추가로
      let weekitem = {
        stName: "",
        edName: "",
      };
      weeks[i] = weekitem;
    }
    list.map((item, index) => {
      item.rb90_weeks = Math.trunc((item.rb90_daily_no - 1) / 6) + 1; // 6개씩이니
      console.log(item.rb90_daily_no + "->" + item.rb90_weeks);

      if (weeks[item.rb90_weeks].stName == "")
        weeks[item.rb90_weeks].stName = getStartBibleName(item.rb90_bible);
      let endName = getEndBibleName(item.rb90_bible);
      if (endName != "") weeks[item.rb90_weeks].edName = endName;
    });

    console.log(weeks);
    list.map((item, index) => {
      item.rb90_week_title =
        item.rb90_weeks +
        "주차 : " +
        weeks[item.rb90_weeks].stName +
        " ~ " +
        weeks[item.rb90_weeks].edName;
    });

    const copyList = [...list];

    setList(copyList);
  };
  const saveBibleList = async () => {
    // 수정인지 저장인지 판단

    // 먼저 삭제

    // 갯수만큼 insert row
    for (let i = 0; i < list.length; i++) {
      saveItem(list[i]);
    }

    // 헤더 생성
    //if(loc.state.bible.rb90_no == 0){
    saveTitle();
    //}
  };

  const saveItem = async (item) => {
    const userSession = getUserSession();

    try {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "rb90_m");
      formData.append("rb90_no", no);
      formData.append("rb90_daily_no", item.rb90_daily_no);
      formData.append("rb90_bible", item.rb90_bible);
      formData.append("rb90_week_title", item.rb90_week_title);
      formData.append("rb90_weeks", item.rb90_weeks);
      formData.append("rb90_date", item.rb90_date);

      let res = await fetch("https://work.wekoinonia.org/json/rbjesus.php", {
        method: "POST",
        body: formData,
        //headers: new Headers({
        //'Content-Type': 'application/json'
        //  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      });

      let json = await res.json(); //Promise 반환
      console.log(json); // 서버에서 주는 json데이터가 출력 됨
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const saveTitle = async () => {
    const userSession = getUserSession();

    let rb90_title = "성경일독을 위한 90일 챌린지";
    let rb90_fdate = list[0].rb90_date;
    let rb90_tdate = list[list.length - 1].rb90_date;
    let fdate_ymd = rb90_fdate.split("-");
    let tdate_ymd = rb90_tdate.split("-");

    let rb90_content =
      "- 기간 : " +
      fdate_ymd[0] +
      "년 " +
      fdate_ymd[1] +
      "월 " +
      fdate_ymd[2] +
      "일(월)~" +
      tdate_ymd[1] +
      "월 " +
      tdate_ymd[2] +
      "일(토)까지 \n" +
      " - 대상 : 90일동안 성경 일독에 도전하고 싶은 모든 성도";

    try {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "rb90_title");
      formData.append("rb90_no", no);
      formData.append("rb90_title", rb90_title);
      formData.append("rb90_content", rb90_content);
      formData.append("fdate", rb90_fdate);
      formData.append("tdate", rb90_tdate);

      let res = await fetch("https://work.wekoinonia.org/json/rbjesus.php", {
        method: "POST",
        body: formData,
        //headers: new Headers({
        //'Content-Type': 'application/json'
        //  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      });

      let json = await res.json(); //Promise 반환
      console.log(json); // 서버에서 주는 json데이터가 출력 됨
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div id="content">
      {" "}
      {/* https://startbootstrap.com/previews/sb-admin 참조*/}
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Page Heading */}
        <h1 className="h3 mb-2 text-gray-800">90일 성경일기 일정관리</h1>
        <span>차수 </span>
        <span>{no}</span>
        <span> [기간</span>{" "}
        <span>
          {fdate} ~ {tdate}]
        </span>
        <br />
        <span> 제목 </span> <span>{title} </span>
        <span> 내용 </span> <span>{content}</span>
        <Button
          variant="outline-success"
          type="button"
          style={{ width: "16rem" }}
          onClick={() => {
            updateRowWeekTitle();
          }}
        >
          주차/주타이틀 일괄변경
        </Button>
        {/* DataTales Example */}
        <div className="card shadow mb-4">
          <div className="card-body">
            <div>
              {/* className="table-responsive" 이게 하단 스크롤바가 생기게 만들어서 */}
              <div
                id="dataTable_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="dataTable-top">
                  <div className="dataTable-dropdown">
                    <label>
                      <select
                        className="dataTable-selector"
                        defaultValue={10}
                        style={{ display: "none" }}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="25">25</option>
                      </select>
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <table
                      className="table table-bordered dataTable"
                      id="dataTable"
                      width="100%"
                      cellSpacing="0"
                      role="grid"
                      aria-describedby="dataTable_info"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr role="row">
                          {/* <th className="sorting sorting_asc" tabIndex="0" aria-controls="dataTable" rowSpan="1" colSpan="1" aria-sort="ascending" style={{width: '2rem'}}></th> */}
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-label=": activate to sort column ascending"
                            style={{ width: "4rem" }}
                          >
                            no
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-label=": activate to sort column ascending"
                            style={{ width: "10rem" }}
                          >
                            일자
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-label=": activate to sort column ascending"
                            style={{ width: "4rem" }}
                          >
                            요일
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="3"
                            aria-label=": activate to sort column ascending"
                            style={{ width: "4rem" }}
                          >
                            조정
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-label=": activate to sort column ascending"
                            style={{ width: "auto" }}
                          >
                            성경
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-label=": activate to sort column ascending"
                            style={{ width: "10rem" }}
                          >
                            주차
                          </th>
                          <th
                            className="sorting"
                            tabIndex="0"
                            aria-controls="dataTable"
                            rowSpan="1"
                            colSpan="1"
                            aria-label=": activate to sort column ascending"
                            style={{ width: "auto" }}
                          >
                            주타이틀
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item, index) => {
                          const url = ``;
                          return (
                            <tr key={index}>
                              {/* <td><Form.Check  value={item.channel_id + "_" + item.channel} onChange={e => selectItem(e)}/></td> */}
                              <td>{item.rb90_daily_no}</td>
                              <td>
                                <Form.Control
                                  type="date"
                                  placeholder="일자"
                                  onChange={(e) => {
                                    changeDate(e.target.value, index);
                                  }}
                                  value={item.rb90_date}
                                  style={{
                                    width: "auto",
                                    border: "0px solid #ffffff",
                                  }}
                                />
                              </td>
                              <td>{item.weekday_name}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    modifyRowModal(index);
                                  }}
                                >
                                  수정
                                </button>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    insertRowDown(index);
                                  }}
                                >
                                  삽입
                                </button>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    deleteRow(index);
                                  }}
                                >
                                  삭제
                                </button>
                              </td>
                              <td>{item.rb90_bible}</td>
                              <td>{item.rb90_weeks}</td>
                              <td>{item.rb90_week_title}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Modal show={modalShow} onHide={modalClose}>
                  <Modal.Header closeButton>
                    <Modal.Title> 수정 </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <FloatingLabel
                      controlId="title"
                      label="성경(내용)"
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        placeholder="내용"
                        value={bibleCont}
                        onChange={(e) => setBibleCont(e.target.value)}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        내용을 입력하세요
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={modalClose}>
                      취소
                    </Button>
                    <Button variant="primary" onClick={modalModify}>
                      수정
                    </Button>
                  </Modal.Footer>
                </Modal>
                <Row>
                  <Col lg={10} className="mx-auto"></Col>
                  <Col lg={2} className="mx-auto">
                    <Button
                      variant="primary"
                      type="button"
                      style={{ width: "8rem" }}
                      onClick={(e) => saveBibleList()}
                    >
                      저장
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*.container-fluid */}
    </div>
  );
};

export default ReadingBible90;
